var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgComment1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M22 3H2C.897 3 0 3.897 0 5v11c0 1.103.897 2 2 2h2.691l-1.138 2.276a.498.498 0 00.656.677l6.4-2.954h11.39c1.103 0 2-.897 2-2v-11c0-1.103-.897-2-2-2zm1 13c0 .552-.449 1-1 1H10.5a.499.499 0 00-.212.047l-5.203 2.401.863-1.725A.498.498 0 005.501 17h-3.5c-.551 0-1-.448-1-1V5c0-.552.449-1 1-1h20c.551 0 1 .448 1 1v11z"
})));
export default SvgComment1;